import { IRound } from 'modules/admin-panel/pages/settings/models';
import { Moment } from 'moment';

export const validateRoundData = (data: IRound) => {
	return !!(
		data.sendRespondentCount &&
		data.offices?.length &&
		data.startDate?.isValid() &&
		data.endDate?.isValid() &&
		data.sendingTime?.isValid()
	);
};
